import { RightOutlined } from '@ant-design/icons';
import { t } from '@hefe/i18n';
import { KnowledgeBaseArticleSearch } from '@hefe/models';
import { KnowledgeBaseApi } from '@hefe/store';
import { Button, Col, Divider, Row, Skeleton, Space, Typography } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import HtmlParser from '../../../core/utils/html-parser/HtmlParser';
import KnowledgeBaseLayout from '../../layout/knowledge-base.layout';
import styles from './knowledge-base-search-results.module.scss';

export default function KnowledgeBaseSearchResultsPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const q = searchParams.get('q') || '';

  const { data, isFetching } = KnowledgeBaseApi.useSearchQuery(q, { skip: !q });

  const renderArticle = (article: KnowledgeBaseArticleSearch) => {
    return (
      <Row
        key={article.id}
        className={styles['article']}
        align="middle"
        justify="center"
        onClick={() => navigate(`/knowledge-base/articles/${article.id}`)}
      >
        <Col xs={23}>
          <Space direction="vertical" size={1}>
            <Typography.Text className={styles['article-breadcrumbs']}>
              {article.breadcrumbs
                .filter((breadcrumb) => breadcrumb.id !== article.id)
                .map((breadcrumb) => breadcrumb.name)
                .join(' > ')}
            </Typography.Text>
            <Typography.Text className={styles['article-title']}>
              {article.title}
            </Typography.Text>
            <Typography.Text className={styles['article-text']}>
              {HtmlParser(article.text)}
            </Typography.Text>
          </Space>
        </Col>
        <Col xs={1}>
          <RightOutlined />
        </Col>
      </Row>
    );
  };

  const renderContent = () => {
    if (isFetching) {
      return (
        <Row>
          <Col xs={24}>
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </Col>
        </Row>
      );
    }

    return (
      <Row>
        <Col xs={24}>
          <Typography.Title level={1}>
            {t('knowledge_base.search.results.title', { term: q })}
          </Typography.Title>
          <Space>
            <Typography.Text strong>
              {t('knowledge_base.categories.plural')}:&nbsp;
            </Typography.Text>
            {data?.categories.map((category) => (
              <Button type="text">{category.name}</Button>
            ))}
          </Space>
          <Divider />
        </Col>
        <Col xs={24}>
          {data?.articles.map((article) => renderArticle(article))}
          <Divider />
        </Col>
        <Col xs={24}>
          <Typography.Title level={3}>
            {t('knowledge_base.search.results.more_relevant_results')}
          </Typography.Title>
          {data?.relevant_articles.map((article) => renderArticle(article))}
        </Col>
      </Row>
    );
  };

  return <KnowledgeBaseLayout>{renderContent()}</KnowledgeBaseLayout>;
}
